import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import { fromJS } from 'immutable';
import api from './api';
import { getSocket } from '../../common/AllSocketsMiddleware';
import getSocketMiddlewareInstance from '../../../genericEnv/common/SocketMiddleware';

const apiCaller = getApiInstance();

export const getAllPushNotifications = () => {
    return apiCaller
        .call(api.getAllPushNotifications())
        .then(({ data }) => {
            if (data.success) {
                return data.pushNotifications;
            }
        })
        .catch(error => {
            Logger.log('dataActions: getFhePushNotifications - ', error);
            throw 'general.error.data_has_not_correctly_returned_by_server';
        });
};
export const getPushNotificationDetails = pushNotificationId => {
    return apiCaller
        .call(api.getPushNotificationDetails(pushNotificationId))
        .then(({ data }) => {
            if (data.success) {
                return data.pushNotificationsDetails[pushNotificationId];
            }
        })
        .catch(error => {
            Logger.log('dataActions: getFhePushNotifications - ', error);
            throw error;
        });
};
export const updatePushNotification = (form, pushNotificationId) => {
    return apiCaller
        .call(api.updatePushNotificationDetails(form, pushNotificationId))
        .then(async ({ data }) => {
            if (data.success) {
                return data.pushNotificationsDetails[pushNotificationId];
            }
        })
        .catch(error => {
            Logger.log('dataActions: updateFhePushNotifications - ', error);
            throw error;
        });
};
export const addPushNotification = form => {
    return apiCaller
        .call(api.addPushNotification(form))
        .then(async ({ data }) => {
            if (data.success) {
                return {
                    pushNotification: data.pushNotificationsDetails[data.pushNotificationId],
                    pushNotificationId: data.pushNotificationId
                };
            }
        })
        .catch(error => {
            Logger.log('dataActions: updateFhePushNotifications - ', error);
            throw error;
        });
};

export const sendPushNotificationEvent = form => {
    return getSocket('multi')
        .sendPushNotification(form)
        .then(data => {
            return data.date;
        })
        .catch(error => {
            Logger.log('dataActions: sendPushNotificationEvent - ', error);
            throw error;
        });
};



// WEBPACK FOOTER //
// ./environments/fhe/data/PushNotifications/actions.js